var map = {
	"./amazon/prodIcon.png": 929,
	"./apple/prodIcon.png": 4151,
	"./ebay/prodIcon.png": 5084,
	"./googleplay/prodIcon.png": 2496,
	"./netflix/prodIcon.png": 1907,
	"./playstation/prodIcon.png": 7565,
	"./steam/prodIcon.png": 5051,
	"./xbox/prodIcon.png": 544
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 946;